import { OrderDetailsCombinedProps } from './types';

const usePresenter = (props: OrderDetailsCombinedProps): OrderDetailsCombinedProps => {
  return props;
};

export default usePresenter;
